import React, { useEffect, useRef } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Header from '../landing/Header/Header';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Bannerchatandrepay = () => {


  

  const textRef = useRef(null);
  const paraRef = useRef(null);
  const buttonRef = useRef(null);


  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(textRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });

    tl.to(textRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(
      paraRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(buttonRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });


    tl.to(buttonRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 0.5,
      ease: "power2.out",
    })

      .to(buttonRef.current, {
        rotateY: 360,
        duration: 0.8,
        ease: "power2.inOut",
      });
  }, []);

  useEffect(() => {
    gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
      opacity: 0,
      y: 10,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(".fade-element", { x: 100, opacity: 0, }, { x: 0, opacity: 1, duration: 1 });
  }, []);

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://tomi.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About US", // ✅ Level 2 in JSON
        "item": "https://tomi.com/aboutus"
      }
    ]
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    document.title = "About Us - Learn about what drives tomi to build a better web";
  
    const updateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[property='${name}']`);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("property", name);
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };
  
    updateMetaTag("og:title", "About Us - Learn about what drives tomi to build a better web");
    updateMetaTag("og:description", "Everything in tomi's ecosystem is driven by core principles of security, privacy, and freedom to bring the best experience to all participants");
  
  }, []);
  

  return (
    <>
      <section className="bannermainprnt">
        <Header />
        <div className="custom-container">
          <div className="heromain">
            <div className="heroleftseaction">
              <div className="textherobanner securlybannerthird">

                <nav aria-label="breadcrumb">
                  <Breadcrumb className="breadcrumbprnt">
                    <Breadcrumb.Item className="breadvrumbcnt" href="/">
                      Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="breadvrumbcnt">
                      Company
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      className="breadvrumbcntactive"
                    >
                      About US
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </nav>
                <h1 className='browssecurlybannerheading' ref={textRef}>About US</h1>
                <p ref={paraRef}>Founded in 2022, TOMI is reshaping how people connect and transact in the digital world. Our app is designed to make communication and crypto transactions simple and secure. Learn more about our journey, vision, and values—and explore our whitepaper to dive deeper into what we’re building.</p>
              </div>
              <a href="/TOMI_Whitepaper_2025.pdf" target="_blank" rel="noopener noreferrer">
                <button ref={buttonRef} className="herofeaturebannerbtn primerybtn">
                  Read Whitepaper
                </button>
              </a>
            </div>
            <div className="herorightseaction">
              <img className="img-fluid desktopimgaboutus fade-element" src="\assets\Aboutus\aboutusbanner.png" alt="aboutusbannerimg" />
              <img className='img-fluid mobileimgaboutus fade-element' src="\assets\Aboutus\aboutusbannersec.png" alt="aboutusbannerimg" />
            </div>
          </div>
        </div>
      </section >
    </>
  )
}

export default Bannerchatandrepay